module.exports = __webpack_public_path__ + "media/images/icons/arrow-right-d31d641644a9a382e4c4511ff2ef6db6.svg";